(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["medical-quebec-price"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('medical-quebec-price')) {
  customElements.define('medical-quebec-price', class extends HTMLElement {
    connectedCallback() {
      if (!this.hasAttribute('data-dynamic') || this.observer) return;
      const data = this.querySelector('script[type="application/json"]');
      const section = this.closest('.product-section');
      const price = section && section.querySelector('[id^="ProductPrice-"]');
      if (!data || !price) return;
      const variants = JSON.parse(data.textContent);
      const normalize = value => value.replace(/\s/g, '');
      this.update = () => {
        const match = variants.find(variant => normalize(variant.base) === normalize(price.textContent));
        this.hidden = !match;
        if (match) this.querySelector('.medical-quebec-price__amount').textContent = match.total;
      };
      this.observer = new MutationObserver(this.update);
      this.observer.observe(price, {childList: true, subtree: true, characterData: true});
      this.update();
    }
    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      this.observer = null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
